"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[4483],{

/***/ 17773:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BestsellersBlock_BestsellersBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/router/shared/hooks.ts
var hooks = __webpack_require__(91746);
// EXTERNAL MODULE: ./local_modules/intersection-observer/useEntry.ts
var useEntry = __webpack_require__(34886);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
// EXTERNAL MODULE: ./src/components/navigation/Tabs/Tabs.tsx + 4 modules
var Tabs = __webpack_require__(36806);
// EXTERNAL MODULE: ./src/compositions/landings/BestsellersBlock/components/ProductList/ProductList.tsx + 1 modules
var ProductList = __webpack_require__(789);
;// CONCATENATED MODULE: ./src/compositions/landings/BestsellersBlock/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Shop best sellers"
    },
    // TODO seems a very common pattern - added on 04.02.2022 by sonatskiy
    perfumes: {
        en: "Perfumes"
    },
    colognes: {
        en: "Colognes"
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/BestsellersBlock/BestsellersBlock.tsx











const tabIds = {
    perfumes: "perfumes",
    colognes: "colognes"
};
const BestsellersBlock = (props)=>{
    const { id, className, title, limit, totalLimit, offset, buttonProps, fetchMoreButtonTitle, withoutLink = true, withRetailPrice, fetchMoreButtonStyle } = props;
    const pathname = (0,hooks/* usePathname */.jD)();
    const { gender, isLoggedIn } = (0,user/* useUser */.aF)();
    const { isMobile, isBot } = (0,useDevice/* default */.Z)();
    const [ref, entry] = (0,useEntry/* default */.Z)({
        once: true,
        observerProps: {
            rootMargin: "25%"
        }
    });
    const isSectionVisible = isBot || (entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    // don't make strict assertion for non-authorized users because of different urls
    const isMale = isLoggedIn ? gender === "MALE" : /\/men/.test(pathname);
    const defaultTab = isMale ? tabIds.colognes : tabIds.perfumes;
    let tabs = [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z.Content, {
            id: tabIds.perfumes,
            title: messages.perfumes,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                limit: limit,
                totalLimit: totalLimit,
                offset: offset,
                catalogueName: "perfumes",
                buttonProps: buttonProps,
                isVisible: isSectionVisible,
                withoutLink: withoutLink,
                withRetailPrice: withRetailPrice,
                fetchMoreButtonTitle: fetchMoreButtonTitle,
                fetchMoreButtonStyle: fetchMoreButtonStyle
            })
        }, "perfumes"),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z.Content, {
            id: tabIds.colognes,
            title: messages.colognes,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                limit: limit,
                totalLimit: totalLimit,
                offset: offset,
                catalogueName: "colognes",
                buttonProps: buttonProps,
                isVisible: isSectionVisible,
                withoutLink: withoutLink,
                withRetailPrice: withRetailPrice,
                fetchMoreButtonTitle: fetchMoreButtonTitle,
                fetchMoreButtonStyle: fetchMoreButtonStyle
            })
        }, "colognes")
    ];
    if (isMale) {
        tabs.reverse();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        ref: ref,
        id: id,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title || messages.title,
                style: isMobile ? "h4" : "h3",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                className: isMobile ? "mt-32" : "mt-40",
                defaultActiveTab: defaultTab,
                children: tabs
            })
        ]
    });
};
/* harmony default export */ const BestsellersBlock_BestsellersBlock = (/*#__PURE__*/react.memo(BestsellersBlock));


/***/ }),

/***/ 789:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductList_ProductList)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueId.ts + 2 modules
var useCatalogueId = __webpack_require__(91491);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueProducts.ts + 1 modules
var useCatalogueProducts = __webpack_require__(32029);
// EXTERNAL MODULE: ./src/compositions/productLists/FetchMoreButtonProductList/FetchMoreButtonProductList.tsx
var FetchMoreButtonProductList = __webpack_require__(18640);
;// CONCATENATED MODULE: ./src/compositions/landings/BestsellersBlock/components/ProductList/messages.ts
/* harmony default export */ const messages = ({
    buttonTitle: {
        en: "View more scents"
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/BestsellersBlock/components/ProductList/ProductList.tsx







const ProductList = (props)=>{
    var _data_products;
    const { catalogueName, buttonProps, isVisible, fetchMoreButtonTitle, fetchMoreButtonStyle, withDetailedMobileCards, withoutLink, withRetailPrice = false, limit, offset = 0, totalLimit = 72 } = props;
    const { catalogueId, isFetching: isFetchingCatalogue } = (0,useCatalogueId/* default */.Z)({
        catalogueName
    });
    const { isMobile } = (0,useDevice/* default */.Z)();
    const productsLimit = limit || (isMobile ? 12 : 6);
    const variables = (0,react.useMemo)(()=>({
            id: catalogueId,
            input: {
                limit: productsLimit,
                offset,
                productsFeed: "PICK_ORDER_BRAND_PARTNERS"
            },
            withCount: true,
            withRetailPrice
        }), [
        catalogueId,
        offset,
        productsLimit,
        withRetailPrice
    ]);
    const { data, isFetching, fetchMore } = (0,useCatalogueProducts/* default */.Z)({
        variables,
        ssr: false,
        notifyOnNetworkStatusChange: true,
        skip: !catalogueId || !isVisible
    });
    const handleFetchMore = (0,react.useCallback)(()=>{
        var _data_products;
        (0,analytics/* track */.j)("Show more products click", {
            placement: "Bestsellers"
        });
        void fetchMore({
            variables: {
                ...variables,
                input: {
                    ...variables.input,
                    offset: data === null || data === void 0 ? void 0 : (_data_products = data.products) === null || _data_products === void 0 ? void 0 : _data_products.length
                }
            }
        });
    }, [
        data === null || data === void 0 ? void 0 : (_data_products = data.products) === null || _data_products === void 0 ? void 0 : _data_products.length,
        fetchMore,
        variables
    ]);
    const totalCount = Math.min(data === null || data === void 0 ? void 0 : data.count, totalLimit);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FetchMoreButtonProductList/* default */.Z, {
        className: "mt-24",
        products: data === null || data === void 0 ? void 0 : data.products,
        totalCount: totalCount,
        isFetching: !isVisible || isFetchingCatalogue || isFetching,
        fetchSkeletonsAmount: productsLimit,
        fetchMoreButtonTitle: fetchMoreButtonTitle || messages.buttonTitle,
        fetchMoreButtonStyle: fetchMoreButtonStyle || "secondary",
        buttonProps: buttonProps,
        fetchMore: handleFetchMore,
        withoutLink: withoutLink,
        withRetailPrice: withRetailPrice,
        withDetailedMobileCards: withDetailedMobileCards,
        excludeLabels: [
            "BESTSELLER",
            "HOLIDAY_SALE",
            "PLUS_FREE_GIFT"
        ]
    });
};
/* harmony default export */ const ProductList_ProductList = (ProductList);


/***/ }),

/***/ 12177:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BottomBanner_BottomBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/banners/HeroBase/HeroBase.tsx + 2 modules
var HeroBase = __webpack_require__(72044);
;// CONCATENATED MODULE: ./src/compositions/landings/BottomBanner/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Over 700 fragrances (and counting!) are waiting for you"
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/BottomBanner/images/bg-desktop.jpg
const bg_desktop_namespaceObject = __webpack_require__.p + "images/bg-desktop_5052f0.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/BottomBanner/images/bg-mobile.jpg
const bg_mobile_namespaceObject = __webpack_require__.p + "images/bg-mobile_134ba8.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/BottomBanner/BottomBanner.tsx






const BottomBanner = (param)=>{
    let { className, button, message } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBase/* default */.Z, {
        className: className,
        title: message || messages.title,
        desktopImage: bg_desktop_namespaceObject,
        mobileImage: bg_mobile_namespaceObject,
        button: button,
        desktopContentAtTop: true,
        wideMT: false,
        wideMB: true,
        "data-testid": "bottomBanner"
    });
};
/* harmony default export */ const BottomBanner_BottomBanner = (BottomBanner);


/***/ }),

/***/ 83721:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BrandsQualityBlock_BrandsQualityBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 5 modules
var Image = __webpack_require__(76884);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/layout/AspectContainer/AspectContainer.tsx
var AspectContainer = __webpack_require__(45600);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Top curated fragrances"
    },
    text: {
        en: "We offer the best designer and niche fragrances on the market selected by our team of experts."
    },
    note: {
        en: `And many more luxury brands to&#32;<br class="onlyMobile" />choose from.`
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/bg-0-desktop.jpg
const bg_0_desktop_namespaceObject = __webpack_require__.p + "images/bg-0-desktop_aef261.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/bg-0-desktop.jpg?src-loader

/* harmony default export */ const bg_0_desktopsrc_loader = ({ src: bg_0_desktop_namespaceObject, aspect: 1.4753, width: 1136, height: 770 });
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/bg-0-mobile.jpg
const bg_0_mobile_namespaceObject = __webpack_require__.p + "images/bg-0-mobile_4d6c11.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/bg-0-mobile.jpg?src-loader

/* harmony default export */ const bg_0_mobilesrc_loader = ({ src: bg_0_mobile_namespaceObject, aspect: 1.3000, width: 832, height: 640 });
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/brands-desktop.png
const brands_desktop_namespaceObject = __webpack_require__.p + "images/brands-desktop_50b547.png";
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/brands-desktop.png?src-loader

/* harmony default export */ const brands_desktopsrc_loader = ({ src: brands_desktop_namespaceObject, aspect: 38.7241, width: 2246, height: 58 });
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/brands-mobile.png
const brands_mobile_namespaceObject = __webpack_require__.p + "images/brands-mobile_a3ee3b.png";
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/brands-mobile.png?src-loader

/* harmony default export */ const brands_mobilesrc_loader = ({ src: brands_mobile_namespaceObject, aspect: 5.2105, width: 792, height: 152 });
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/BrandsQualityBlock.tsx











const BrandsQualityBlock = (props)=>{
    const { className, button = null, subtitle, title, text, mobileImage: customMobileImage, desktopImage: customDesktopImage } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const mobileImage = customMobileImage || bg_0_mobilesrc_loader;
    const desktopImage = customDesktopImage || bg_0_desktopsrc_loader;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)(className, "bg-light-beige"),
            "data-testid": "brandsSection",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                    aspect: mobileImage.aspect,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: mobileImage.src,
                        sizes: "100vw",
                        fill: true,
                        alt: "Bottles"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-16 pt-24 text-center",
                    children: [
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mb-8",
                            message: subtitle,
                            style: "eye2",
                            color: "gold-70"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: title || messages.title,
                            style: "h4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-24",
                            message: text || messages.text,
                            style: "p3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            className: "mt-24 w-full",
                            src: brands_mobilesrc_loader,
                            alt: "Bvlgari, Tocca, Kenneth Cole, Michael Kors, Marc Jacobs, Balenciaga",
                            sizes: "100vw"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-24",
                            message: messages.note,
                            style: "p3",
                            html: true
                        }),
                        button
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        className: className,
        "data-testid": "brandsSection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between bg-light-beige",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-464 py-32 pl-64 pr-32",
                        children: [
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: "mb-8",
                                message: subtitle,
                                style: "eye2",
                                color: "gold-70"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: title || messages.title,
                                style: "h3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: "mt-24",
                                message: text || messages.text,
                                style: "p3"
                            }),
                            button
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                        className: "w-6/12",
                        aspect: desktopImage.aspect,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: desktopImage.src,
                            alt: "Bottles",
                            fill: true,
                            sizes: "568px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: "mt-24 w-full px-12",
                src: brands_desktopsrc_loader,
                alt: "Bvlgari, Michael Kors, Marc Jacobs, Tocca, Balenciaga",
                sizes: "1136px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-24 text-center",
                message: messages.note,
                style: "p1",
                html: true
            })
        ]
    });
};
/* harmony default export */ const BrandsQualityBlock_BrandsQualityBlock = (/*#__PURE__*/react.memo(BrandsQualityBlock));


/***/ }),

/***/ 87902:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ContinueStickyBar_ContinueStickyBar)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(39977);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/dataDisplay/Logo/Logo.tsx
var Logo = __webpack_require__(53409);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(30468);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
// EXTERNAL MODULE: ./src/compositions/buttons/SubscribeButton/SubscribeButton.tsx
var SubscribeButton = __webpack_require__(46181);
// EXTERNAL MODULE: ./src/pages/landing/View/components/GetStartedButton/GetStartedButton.tsx + 1 modules
var GetStartedButton = __webpack_require__(99324);
;// CONCATENATED MODULE: ./src/compositions/landings/ContinueStickyBar/messages.ts
/* harmony default export */ const ContinueStickyBar_messages = ({
    faq: {
        en: "FAQ"
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/ContinueStickyBar/ContinueStickyBar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ContinueStickyBar_module = ({"root":"uMmluY","visible":"K_dD6A"});
;// CONCATENATED MODULE: ./src/compositions/landings/ContinueStickyBar/ContinueStickyBar.tsx














const ContinueStickyBar = (props)=>{
    const { isVisible, desktopText, continueButtonMessage, eventDiscountText, customButton, coupon, onContinue } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const isMountedRef = (0,react.useRef)(false);
    const handleContinueClick = (0,react.useCallback)(()=>{
        (0,analytics/* track */.j)("Banner click", {
            placement: "Sticky bar",
            content: "Subscribe",
            action: "link",
            link: links/* default */.ZP.subscribe,
            discount: eventDiscountText,
            coupon
        });
        if (typeof onContinue === "function") {
            onContinue();
        }
    }, [
        eventDiscountText,
        coupon,
        onContinue
    ]);
    const handleFaqClick = (0,react.useCallback)(()=>{
        (0,analytics/* track */.j)("FAQ link click", {
            placement: "Sticky bar"
        });
        (0,manager/* openModal */.h7)("faqModal");
    }, []);
    (0,react.useEffect)(()=>{
        isMountedRef.current = true;
    }, [
        isVisible
    ]);
    const rootClassName = (0,clsx/* default */.Z)(isMobile ? "grid grid-cols-2" : "bg-gold-30 py-24", ContinueStickyBar_module.root, isVisible && ContinueStickyBar_module.visible, isMountedRef.current ? "" : "hidden", "fixed inset-x-0 top-0 z-floating-header");
    let primaryButton;
    if (customButton) {
        const ButtonComponent = (customButton === null || customButton === void 0 ? void 0 : customButton.actionType) === "subscribe" ? SubscribeButton/* default */.Z : GetStartedButton/* default */.Z;
        const buttonProps = {
            size: 56,
            width: isMobile ? null : 240,
            className: "bg-deep-purple",
            ...customButton
        };
        primaryButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, {
            ...buttonProps,
            placement: "Brand block"
        });
    } else {
        primaryButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: "!bg-deep-purple",
            title: continueButtonMessage || messages/* default */.Z.continue,
            inlineIcon: "32/arrow-right",
            to: links/* default */.ZP.subscribe,
            size: 56,
            width: isMobile ? null : 240,
            onClick: handleContinueClick,
            "data-testid": "subscribeButton"
        });
    }
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: rootClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: ContinueStickyBar_messages.faq,
                        size: 56,
                        style: "gold-30",
                        onClick: handleFaqClick,
                        "data-testid": "faqButton"
                    }),
                    primaryButton
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: "flex items-center justify-end",
            children: [
                desktopText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mr-auto",
                    message: desktopText,
                    style: "p2",
                    html: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                    className: "mr-auto",
                    color: "black"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "mr-16",
                    title: ContinueStickyBar_messages.faq,
                    size: 56,
                    width: 240,
                    style: "secondary",
                    onClick: handleFaqClick,
                    "data-testid": "faqButton"
                }),
                primaryButton
            ]
        })
    });
};
/* harmony default export */ const ContinueStickyBar_ContinueStickyBar = (/*#__PURE__*/react.memo(ContinueStickyBar));


/***/ }),

/***/ 80246:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HowItWorksBlock_HowItWorksBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 5 modules
var Image = __webpack_require__(76884);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
// EXTERNAL MODULE: ./src/components/layout/ScrollableContainer/ScrollableContainer.tsx
var ScrollableContainer = __webpack_require__(90076);
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Here's how it works:"
    },
    slides: [
        {
            title: {
                en: "1. Pick a scent"
            },
            text: {
                en: "Choose what you'd like to try from our best sellers — you'll get access to our full catalog after subscribing."
            }
        },
        {
            title: {
                en: "2. Activate your subscription"
            },
            text: {
                en: "Once your subscription is active, the 8 mL bottle of your choosing will be sent directly to you."
            }
        },
        {
            title: {
                en: "3. Receive your fragrance"
            },
            text: {
                en: `Your first bottle will come dressed in a free atomizer case, and the 8 mL bottle holds roughly 120 sprays, which should last until your next order.`
            }
        }
    ]
});

;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-1.jpg
const how_1_namespaceObject = __webpack_require__.p + "images/how-1_9f7abc.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-1.jpg?src-loader

/* harmony default export */ const how_1src_loader = ({ src: how_1_namespaceObject, aspect: 1.8400, width: 736, height: 400 });
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-2.jpg
const how_2_namespaceObject = __webpack_require__.p + "images/how-2_7dcc25.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-2.jpg?src-loader

/* harmony default export */ const how_2src_loader = ({ src: how_2_namespaceObject, aspect: 1.8400, width: 736, height: 400 });
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-3.jpg
const how_3_namespaceObject = __webpack_require__.p + "images/how-3_dcf981.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-3.jpg?src-loader

/* harmony default export */ const how_3src_loader = ({ src: how_3_namespaceObject, aspect: 1.8400, width: 736, height: 400 });
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-1.jpg
const restyle_how_1_namespaceObject = __webpack_require__.p + "images/how-1_e81c41.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-1.jpg?src-loader

/* harmony default export */ const restyle_how_1src_loader = ({ src: restyle_how_1_namespaceObject, aspect: 1.8400, width: 1104, height: 600 });
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-2.jpg
const restyle_how_2_namespaceObject = __webpack_require__.p + "images/how-2_e0bbaa.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-2.jpg?src-loader

/* harmony default export */ const restyle_how_2src_loader = ({ src: restyle_how_2_namespaceObject, aspect: 1.8400, width: 1104, height: 600 });
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-3.jpg
const restyle_how_3_namespaceObject = __webpack_require__.p + "images/how-3_32e956.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-3.jpg?src-loader

/* harmony default export */ const restyle_how_3src_loader = ({ src: restyle_how_3_namespaceObject, aspect: 1.8400, width: 1104, height: 600 });
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/HowItWorksBlock.tsx













const HowItWorksBlock_images = [
    how_1src_loader,
    how_2src_loader,
    how_3src_loader
];
const restyleImages = [
    restyle_how_1src_loader,
    restyle_how_2src_loader,
    restyle_how_3src_loader
];
const getDefaultItems = (isRestyle)=>{
    return messages.slides.map((param, index)=>{
        let { title, text } = param;
        return {
            title,
            text,
            image: isRestyle ? restyleImages[index] : HowItWorksBlock_images[index]
        };
    });
};
const HowItWorksBlock = (props)=>{
    const { children, className, title, items, restyleDefaultImages } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    let finalItems = items || getDefaultItems(restyleDefaultImages);
    const slidesNode = finalItems.map((param, index)=>{
        let { title, text, image } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "snap-start scroll-ml-16 text-left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    className: "object-cover object-center",
                    src: image,
                    alt: "",
                    remWidth: isMobile ? 356 : 368
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-16",
                    message: title,
                    style: "h6"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-8",
                    message: text,
                    style: "p2"
                })
            ]
        }, image.src || index);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        className: (0,clsx/* default */.Z)("text-center", className),
        "data-testid": "howItWorksSection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-32",
                message: title || messages.title,
                style: isMobile ? "h5" : "h3"
            }),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                className: "grid snap-x snap-mandatory auto-cols-[356rem] grid-flow-col gap-x-16",
                children: slidesNode
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-3 gap-16",
                children: slidesNode
            }),
            children
        ]
    });
};
/* harmony default export */ const HowItWorksBlock_HowItWorksBlock = (/*#__PURE__*/react.memo(HowItWorksBlock));


/***/ })

}]);